import { render, staticRenderFns } from "./MemberIdentityVerification.vue?vue&type=template&id=ab4c71cc&scoped=true"
import script from "./MemberIdentityVerification.vue?vue&type=script&lang=js"
export * from "./MemberIdentityVerification.vue?vue&type=script&lang=js"
import style0 from "./MemberIdentityVerification.vue?vue&type=style&index=0&id=ab4c71cc&prod&lang=css"
import style1 from "./MemberIdentityVerification.vue?vue&type=style&index=1&id=ab4c71cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4c71cc",
  null
  
)

export default component.exports